import { ReservationPurpose as ReservationPurposeEnum } from '@mews-commander/data-access';
import { enumify, Enumify } from '@mews/enumify';

function ReservationPurpose() {}
enumify<ReservationPurposeEnum, ReservationPurposeEnum>(
    ReservationPurpose,
    'ReservationPurpose',
    ReservationPurposeEnum
);

export default ReservationPurpose as unknown as Enumify<ReservationPurposeEnum, ReservationPurposeEnum>;
